import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import UsePointsPage from './UsePointsPage';
import './UsePointsPage.less';

export const prefix = 'bm-p-use-points';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: UsePointsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});

export default RouteComponent;
